module.exports = __webpack_public_path__ + "static/media/2.18f1fe38.png";